module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/113-greenland-bd29bf8c74caf8396362efe0ca88d332.svg";